import { useNavigate, useParams } from 'react-router-dom';
import { Button, Panel } from 'nhsuk-react-components';
import useFetchSpecificCampaign from 'queries/fetch/fetchSpecificCampaign.ts';
import ProgressIndicator from 'components/ProgressIndicator/index.tsx';
import { ICampaignLevelParams } from 'utils/parameterUtils';

function IterationDetailsConfirmationPage() {
  const { teamId, campaignId } = useParams() as ICampaignLevelParams;
  const { data: campaign, isLoading: campaignIsLoading } = useFetchSpecificCampaign({ teamId, campaignId });

  const navigate = useNavigate();
  const { iterationId } = useParams();

  const handleContinue = () => {
    navigate(`/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary`);
  };

  if (campaignIsLoading || !campaign) {
    return <ProgressIndicator text="Loading campaign..." />;
  }

  return (
    <>
      <Panel>
        <Panel.Title>{`Iteration '${campaign.CampaignConfig.Name}' has been updated`}</Panel.Title>
        <div>
          The next screen will show the iteration summary.
        </div>
      </Panel>
      <Button onClick={handleContinue}>Continue</Button>
    </>
  );
}

export default IterationDetailsConfirmationPage;
